<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 车辆管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container'>
            <div class='handle-box'>

                <el-input v-model='query.licensePlate' placeholder='车牌号' class='handle-input mr10'
                          style='width: 140px;margin-right: 20px'></el-input>


                <el-button type='primary' icon='el-icon-search' @click='handleSearch'>查询</el-button>
                <el-button type='primary' icon='el-icon-plus' @click='addUser'>添加</el-button>


            </div>

            <el-table
                :data='tableData'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >
                <el-table-column label='序号' align='center' :index='indexMethod' type='index' width='40'>
                </el-table-column>
                <el-table-column label='车牌号' align='center'>
                    <template slot-scope='scope'>{{ scope.row.licensePlate }}</template>
                </el-table-column>
                <el-table-column label='驾驶员' align='center'>
                    <template slot-scope='scope'>{{ scope.row.driverName }}</template>
                </el-table-column>
                <el-table-column label='GPS设备ID' align='center'>
                    <template slot-scope='scope'>{{ scope.row.gpsDeviceId }}</template>
                </el-table-column>

                <el-table-column label='车辆状态' align='center'>
                    <template slot-scope='scope'>{{ scope.row.speedName }}</template>
                </el-table-column>

                <el-table-column label='采集时间' align='center'>
                    <template slot-scope='scope'>{{ scope.row.createTime }}</template>
                </el-table-column>

                <el-table-column prop='createTime' label='添加时间' align='center'>
                    <template slot-scope='scope'>{{ scope.row.createTime }}</template>

                </el-table-column>
                <el-table-column label='操作' width='240' align='center'>
                    <template slot-scope='scope'>
                        <el-button
                            type='text'
                            icon='el-icon-edit'
                            @click='handleEdit(scope.$index, scope.row)'
                        >编辑查看
                        </el-button>
                        <el-button
                            type='text'
                            @click='showMap(scope.$index, scope.row)'
                        >查看轨迹
                        </el-button>
                        <el-button
                            type='text'
                            icon='el-icon-delete'
                            class='red'
                            @click='handleDelete(scope.$index, scope.row)'
                        >删除
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>
            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page='query.pageIndex'
                    :page-size='query.pageSize'
                    :total='pageTotal'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>
        <el-dialog title='编辑车辆' :visible.sync='editVisible' width='40%'>
            <el-form ref='form' :model='form' label-width='120px'>

                <el-form-item label='车牌号'>
                    <el-input v-model='form.licensePlate' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='驾驶员'>
                    <el-select v-model='form.driverId' placeholder='请选择驾驶员'
                               style='width: 140px;margin-right: 20px'>
                        <el-option
                            v-for='item in driverOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label='Gps设备ID'>
                    <el-input v-model='form.gpsDeviceId' ></el-input>
                </el-form-item>


            </el-form>

            <span slot='footer' class='dialog-footer'>
                <el-button @click='editVisible = false'>取 消</el-button>
                <el-button type='primary' @click='editHttp' >确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title='添加车辆' :visible.sync='addVisible' width='40%'>


            <el-form ref='form' :model='form' label-width='120px'>

                <el-form-item label='车牌号'>
                    <el-input v-model='createForm.licensePlate' maxlength='11'></el-input>
                </el-form-item>

                <el-form-item label='驾驶员'>
                    <el-select v-model='createForm.driverId' placeholder='请选择驾驶员'
                               style='width: 140px;margin-right: 20px'>
                        <el-option
                            v-for='item in driverOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label='GPS设备ID'>
                    <el-input v-model='createForm.gpsDeviceId' ></el-input>
                </el-form-item>

            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='addVisible = false'>取 消</el-button>
                <el-button type='primary' @click='addUserHttp' :loading="submitLoading" :disabled='submitLoading'>确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog  title='车辆轨迹' :visible.sync='showMapVis' width='80%'  >
            <div class='handle-box'>
                <el-date-picker
                    v-model='dateValue'
                    type='daterange'
                    range-separator='至'
                    start-placeholder='开始日期'
                    end-placeholder='结束日期'>
                </el-date-picker>


                <el-button type='primary' icon='el-icon-search' @click='handleCar'>查询</el-button>


            </div>

            <baidu-map   class="map" :zoom="12"  :center='center'>

                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                <bm-polyline :path="points" :editing="true" @lineupdate="update"></bm-polyline>
                <bm-marker :position="lastPonit" :dragging="true"  :icon="{url: 'http://api.map.baidu.com/library/LuShu/1.2/examples/car.png', size: {width: 50, height: 50}}"></bm-marker>            </baidu-map>


            <span slot='footer' class='dialog-footer'>
                <el-button type='primary' @click='showMapVis=false'>确 定</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
import { countDown, formatDate, formatDates } from '@/utils/formatDate';
import { baseUrl } from '@/utils/nHttp';
import {BmlLushu} from 'vue-baidu-map'
import {BmlCurveLine,MyOverlay} from 'vue-baidu-map'

export default {

    components: {
        BmlCurveLine,
        MyOverlay
    },
    name: 'basetable',
    data() {
        return {
            submitLoading:false,
            dateValue: [],
            lastPonit:{},
            points: [
                {lng: 116.432045, lat: 39.910683},
                {lng: 120.129721, lat: 30.314429},
                {lng: 121.491121, lat: 25.127053}
            ],
            center:{},
            location: '玉环县',
            keyword: '',
            play: true,
            path: [  {lng: 120.53730307190105, lat: 27.48023710617771},
                {lng: 120.53357393464805, lat: 27.485530009633994},
                {lng: 120.53876253658719, lat: 27.488941212138432}],
            icon: {
                url: 'http://api.map.baidu.com/library/LuShu/1.2/examples/car.png',
                size: {width: 52, height: 26},
                opts: {anchor: {width: 27, height:13}}
            },
            enterpriseSearchId:"",
            enterpiseOptionsSearch:[],
            query: {
                name: '',
                pageIndex: 1,
                pageSize: 10
            },
            queryService: {
                name: '',
                pageIndex: 1,
                pageSize: 10000
            },
            memberVisible:false,
            tableData: [],
            multipleSelection: [],
            delList: [],
            cardPwdType: '0',
            editVisible: false,
            addVisible: false
            ,
            createForm: {}
            ,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
            options: [],
            value: [],
            editValue: [],
            provinceOptions: [],
            cityOptions: [],
            provinceValue: '',
            cityValue:"",
            areaOptions:[],
            areaValue:"",
            editCurrentProgress: '1',
            editCurrentProgressName: '',
            serviceProviderOptions: [],
            serviceProviderValue: [],
            lastEnterpriseOptions: [],
            lastEnterpriseValue: '',
            memberStartTimeStr:"",
            memberEndTimeStr:"",
            driverOptions:[],
            showMapVis:false,
            carId:""


        };
    },
    created() {
        this.getData();
        this.getDriverList();
        // this.getEnterpiseSearch();
        // this.getCity();

    },
    methods: {
        update (e) {
            this.points = e.target.cornerPoints
        },
        getLocation(e){
            this.longitude=e.point.lng
            this.latitude=e.point.lat
            this.infoWindowShow=true
            this.getLongitudeAndLatitude();
        },
       getTrajectoryCarById(carId){
           let that = this;
           let param = {}
           param.carId=carId;
           if (this.dateValue != null && this.dateValue.length == 2) {
               console.log(formatDate(this.dateValue[0]));
               param.startDate = formatDate(this.dateValue[0]).substring(0, 10);
               param.endDate = formatDate(this.dateValue[1]).substring(0, 10);
           } else {
               param.startDate = '';
               param.endDate = '';
           }
           this.http.get('Cockpit/getTrajectoryCarById', param).then(res => {
                   if (res.code == 0) {
                      that. points=[]
                       that.lastPonit={}
                       if (res.data.length==0){
                          this.$message.error("暂无车辆轨迹")
                       }else {
                           that.center={"lng":res.data[0].lng,"lat":res.data[0].lat}
                           that.lastPonit=that.center
                           for (let index in res.data) {

                               let resData = res.data[index]
                               that.points.push({"lng":resData.lng,"lat":resData.lat})

                           }
                       }





                   }
               },
               err => {

               });
       },
        getDriverList() {
            let that = this;
            let param = {}
            param.pageIndex=1;
            param.pageSize=9999
            param.role=1
            this.http.get('user/getUserList', param).then(res => {
                    if (res.code == 0) {
                        that.driverOptions=[]
                        that.driverOptions.push({ 'value': '', 'label': '请选择司机' });
                        res.data.records.forEach(res => {
                           that.driverOptions.push({ 'value': res.id, 'label': res.name });
                        });

                    }
                },
                err => {

                });
        },


        reset () {
            this.play = false
        },
        handleSearchComplete (res) {
            this.path = res.getPlan(0).getRoute(0).getPath()
        },


        //禁用
        handleForbidden(index, row) {
            // 二次确认删除
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';

                msg = '确定要审批通过吗？' ;
                params = { 'id': row.id, 'status': 1 };

//0不可用1可用
            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.post('qwpenterprise/updateStatus', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        indexMethod(index) {
            return index + 1;
        },
        getCity() {

        },
        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex = 1;
            this.query.provinceId = this.provinceValue;
            this.query.cityId = this.cityValue;

            this.getData();

        }
        ,
        // 触发搜索按钮
        handleCar() {


            this.getTrajectoryCarById(this.carId);

        }
        ,
        getData() {
            let that = this;

            this.http.getToken('/SewageTank/getCarList', this.query).then(res => {
                    if (res.code == 0) {

                        that.tableData = res.data.records;
                        that.pageTotal = parseInt(res.data.total);
                        this.$message.success('获取数据成功');
                    }
                },
                err => {

                });
        },
        delUserHttp(id) {
            let that = this;
            this.http.postToken('/SewageTank/delCardById', { 'id': id }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },

        addUser() {
            this.getDriverList();
            this.addVisible = true;
            this.createForm = {};

        },

        addUserHttp() {
            let that = this;
            that.submitLoading = true
            this.http.postToken('SewageTank/addCar', this.createForm).then(res => {
                if (res.code === 0) {
                    that.getData();
                    that.addVisible = false;
                    this.$message.success('添加成功');

                }
                // 设置一个1000毫秒后执行的定时任务
                setTimeout(function() {
                    that.submitLoading=false;
                }, 1000);
            });
        }

,
        editHttp() {
            console.log(this.form)

            let that = this;

            // this.form.provinceId = this.form.value[0];
            // this.form.cityId = this.form.value[1];
            // this.form.cardPwdType = this.cardPwdType;


            this.http.postToken('SewageTank/editCarById', this.form).then(res => {
                if (res.code == 0) {
                    that.getData();
                    that.editVisible = false;
                    that.$message.success('编辑成功');
                }
            });
        }
        ,
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;

            this.form = JSON.parse(JSON.stringify(row));

            this.editVisible = true;
        },
        // 编辑操作
        showMap(index, row) {
            this.idx = index;

            this.form = JSON.parse(JSON.stringify(row));
            this.showMapVis=  true;
            this.carId = this.form.id
            this.getTrajectoryCarById(this.form.id);
        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.map{
    width: 100%;
    height: 760px;
}
</style>
